import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { InventoryBoard } from '@/features/inventory/pages/InventoryPage'

import { AdminHeader } from '../AdminLayout'

/**
 * Les stocks, vus du back-office.
 *
 * Le même tableau qu'en réserve, et volontairement le même code : deux écrans
 * pour un seul stock auraient divergé au premier correctif, et l'on aurait
 * passé une soirée à se demander lequel dit vrai.
 *
 * Ce qui change ici n'est pas l'écran mais la question qu'on lui pose. En
 * réserve, on saisit — une livraison arrive, un carton tombe. Au back-office,
 * on regarde : quel rayon est tendu, et combien d'argent dort sur les
 * étagères. C'est pour cette seconde question que le prix d'achat existe, et
 * qu'il est réservé à ceux qui répondent des chiffres.
 */
export function AdminStockPage() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('admin.section.stock')
  }, [t])

  return (
    <>
      <AdminHeader
        title={t('admin.section.stock')}
        description={t('admin.stock.intro')}
      />
      <InventoryBoard />
    </>
  )
}
